import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import expenseInitialValues from "./form/expenseInitialValues";
import expenseSchema from "./form/expenseValidationSchema";
import notify from "../../services/notify";
import ExpenseVehicleSection from "./components/ExpenseVehicleSection/ExpenseVehicleSection.jsx";
import ExpenseInfoSection from "./components/ExpenseInfoSection/ExpenseInfoSection.jsx";
import ExpenseDescriptionSection from "./components/ExpenseDescriptionSection/ExpenseDescriptionSection.jsx";
import ExpenseReceiptSection from "./components/ExpenseReceiptSection/ExpenseReceiptSection.jsx";
import styles from "./ExpenseForm.module.css";
import useExpenseFormLoad from "./hooks/useExpenseFormLoad";
import mapExpenseToForm from "./utils/mapExpenseToForm";
import useExpenseSubmit from "./hooks/useExpenseSubmit";
import { useSelector } from "react-redux";
import { selectCars } from "../../redux/car/car-slice";
import useExpenseCategories from "./hooks/useExpenseCategories";
import { useState } from "react";
import ConfirmDialog from "../../conponents/confirmDialog/ConfirmDialog";
import { normalizeNumber } from "../../services/numberFormatter";



const ExpenseForm = ({

    mode = "create",

    expenseId = null,

    // cars,

    // categories,

}) => {

    const cars = useSelector(selectCars);

    const [

        kilometerDialog,
    
        setKilometerDialog,
    
    ] = useState(false);
    
    const [
    
        pendingValues,
    
        setPendingValues,
    
    ] = useState(null);

    const {

        categories,

        loading: categoriesLoading,
    
    } = useExpenseCategories();

    const navigate = useNavigate();

    const submitExpense = useExpenseSubmit({

        mode,
    
        expenseId,
    
    });

    const {

        expense,
    
        loading,
    
    } = useExpenseFormLoad(
    
        mode === "edit"
    
            ? expenseId
    
            : null
    
    );

    const formik = useFormik({

        initialValues:

                    expense

                        ?

                        mapExpenseToForm(expense)

                        :

                        expenseInitialValues,

        validationSchema: expenseSchema,

        enableReinitialize: true,

        onSubmit: async (

            values,

            { setSubmitting }

        ) => {

            try {

                const selectedCar = cars.find(

                    x => x.id === values.carId
                
                );
                
                const oldKm = normalizeNumber(

                    selectedCar?.kilometer ?? 0
                
                );
                 
                const newKm = Number(
                
                    values.operDonKM
                
                );
             
                if (
                
                    newKm > oldKm
                
                ) {
                
                    setPendingValues(values);
                 
                    setKilometerDialog(true);
                
                    return;
                
                }
                
                await submitData(values);

            }

            catch (error) {

                console.error(error);

                notify.error(error);

            }

            finally {

                setSubmitting(false);

            }

        },

    });

    const submitData = async (values) => {

        await submitExpense(values);
    
        notify.success(
    
            mode === "create"
    
                ? "هزینه با موفقیت ثبت شد."
    
                : "هزینه با موفقیت ویرایش شد."
    
        );
    
        navigate("/all-expense");
    
    };

    const confirmKilometer = async () => {

        try {
    
            setKilometerDialog(false);
    
            if (!pendingValues) {
    
                return;
    
            }
    
            await submitData(pendingValues);
    
            setPendingValues(null);
    
        }
    
        catch (error) {
    
            console.error(error);
    
            notify.error(error);
    
        }
    
    };

    const cancelKilometer = () => {

        setKilometerDialog(false);
    
        setPendingValues(null);
    
    };

    return (

        <form

            className={styles.form}

            onSubmit={formik.handleSubmit}

        >

            <ExpenseVehicleSection

                cars={cars}

                values={formik.values}

                errors={formik.errors}

                touched={formik.touched}

                setFieldValue={formik.setFieldValue}

                setFieldTouched={formik.setFieldTouched}

            />

            <ExpenseInfoSection

                categories={categories}

                values={formik.values}

                errors={formik.errors}

                touched={formik.touched}

                setFieldValue={formik.setFieldValue}

                setFieldTouched={formik.setFieldTouched}

            />

            <ExpenseDescriptionSection

                values={formik.values}

                errors={formik.errors}

                touched={formik.touched}

                handleChange={formik.handleChange}

                handleBlur={formik.handleBlur}

            />

            <ExpenseReceiptSection

                values={formik.values}

                imageUrl={formik.values.imageUrl}

                setFieldValue={formik.setFieldValue}

            />

            <ConfirmDialog

                open={kilometerDialog}

                title="بروزرسانی کیلومتر خودرو"

                message={`

                    آیا مایل هستید کیلومتر خودرو به

                    ${Number(pendingValues?.operDonKM ?? 0).toLocaleString("fa-IR")}
                    
                    کیلومتر بروزرسانی شود؟

                `}

                confirmText="بله"

                cancelText="خیر"

                onConfirm={confirmKilometer}

                onCancel={cancelKilometer}

            />

            <button

                type="submit"

                className={styles.submit}

                disabled={formik.isSubmitting}

            >

                {

                    formik.isSubmitting

                        ? "در حال ثبت..."

                        : "ثبت هزینه"

                }

            </button>

        </form>

    );

};

export default ExpenseForm;